<template>
  <v-app-bar
    app
    color="white"
    elevation="0"
  >
    <div class="d-flex align-center">
      <v-btn
        icon
        class="flex-grow-0"
        @click="close()"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-toolbar-title
      class="flex-grow-1
      flex-md-grow-0
      text-center
      pl-md-4">
        {{ title }}
    </v-toolbar-title>

    <div class="d-flex align-center">
      <v-btn
        icon
        dark
        class="flex-grow-0"
        disabled
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

<!--     <div class="d-flex align-center">
      <v-btn text color="accent">
        EDITAR
      </v-btn>
    </div> -->

  </v-app-bar>
</template>

<style scoped>
  .v-app-bar {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  >>> .v-toolbar__content {
    padding: 0px 8px;
  }
</style>

<script>
export default {
  name: 'MainTopbar',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    score() {
      return this.$store.state.score.score || 0;
    },
  },
  methods: {
    close() {
      this.$emit('close');

      if (window.history.length > 1) {
        this.$router.back();
      } else {
        window.close();
      }
    },
  },
};
</script>
